module.exports = __webpack_public_path__ + "static/bus_traslado-63f00fc0134d59dce8e8f40eb3ea7b15.jpg";